function Research2023() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2023</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-16">Nov</div>
                    <div className="w-full">
                        <p><a href="https://mathsci.kaist.ac.kr/ko/schedule/scView.php?idx=-3185" target='_blank'>“Finite path integral model and toric code based on homological algebra.”</a></p>
                        <p>Topology Seminar, KAIST</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Nov</div>
                    <div className="w-full">
                        <p><a href="https://visgat.cayley.kr/" target='_blank'>“An obstruction problem associated with finite path integral.”</a></p>
                        <p>VISGAT, Korea Institute for Advanced Study</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Oct</div>
                    <div className="w-full">
                        <p><a href="https://www.ocw.titech.ac.jp/index.php?module=General&action=T0300&GakubuCD=4&GakkaCD=342222&KeiCD=22&course=22&KougiCD=202304013&Nendo=2023&lang=EN&vid=03" target='_blank'>“Dijkgraaf-Witten theory and Toric code.”</a></p>
                        <p>Discrete, Algebraic and Geometric Structures, Tokyo Institute of Technology</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Oct</div>
                    <div className="w-full">
                        <p><a href="https://www.ms.u-tokyo.ac.jp/~kawazumi/Tokyo_Seoul_2023.html" target='_blank'></a>“Finite path integral model and toric code based on homological algebra.”</p>
                        <p>Tokyo-Seoul Conference in Mathematics, 2023 Topology and Geometric Group Theory, University of Tokyo</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Oct</div>
                    <div className="w-full">
                        <p><a href="https://ithems.riken.jp/ja/events/interactions-between-algebraic-topology-and-representation-theory-by-toric-code" target='_blank'>“Interactions between Topology and Representation theory by Toric code.”</a></p>
                        <p>iTHEMS Math Seminar, RIKEN</p>
                    </div>
                </div>
                <div className="flex mt-2">
                    <div className="w-16">Aug</div>
                    <div className="w-full">
                        <p><a href="https://www.mathsoc.jp/section/topology/topsymp.html" target='_blank'>“Finite path integral model and toric code based on homological algebra.”</a></p>
                        <p>the 70th Topology Symposium, Nara Women’s University</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Aug</div>
                    <div className="w-full">
                        <p><a href="https://groups.oist.jp/ja/mtpu/event/silver-workshop-vi" target='_blank'>“Finite path integral model and toric code based on homological algebra.”</a></p>
                        <p>Silver workshop VI, OIST</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2023;